import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import { useAuth } from '../../context/AuthContext';
import useHeartbeat from '../../hooks/useHeartbeat';
import useChatNotification from '../../hooks/useChatNotification';
import BirthdayPopup from '../common/BirthdayPopup';

export default function DashboardLayout() {
  const { user } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Keep user's online status active
  useHeartbeat();

  // Global chat notification sound – plays whenever a new chat arrives
  useChatNotification();

  return (
    <>
      {/* Birthday notification popup */}
      <BirthdayPopup />
      <div className="flex min-h-screen bg-[#F8FAFB]">
      {/* Mobile overlay */}
      {sidebarOpen && (
        <div className="fixed inset-0 bg-black/40 z-40 lg:hidden" onClick={() => setSidebarOpen(false)} />
      )}

      <Sidebar mobileOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <div className="flex-1 flex flex-col min-w-0">
        {/* Top Header */}
        <header className="bg-white border-b border-gray-200 sticky top-0 z-30">
          <div className="flex items-center justify-between px-4 lg:px-8 h-16">
            <div className="flex items-center gap-3">
              <button
                className="lg:hidden p-2 rounded-lg text-gray-600 hover:bg-gray-100 transition"
                onClick={() => setSidebarOpen(true)}
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              </button>
              <div>
                <h2 className="text-lg font-bold text-gray-900" style={{ fontFamily: "'Playfair Display', serif" }}>
                  NIS FCT Branch Portal
                </h2>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <span className="hidden sm:block text-sm text-gray-600">
                {user?.first_name} {user?.last_name}
              </span>
              <div className="w-9 h-9 rounded-full bg-[#0B5D1E] text-white flex items-center justify-center text-sm font-bold">
                {user?.first_name?.charAt(0) || 'U'}
              </div>
            </div>
          </div>
        </header>

        <main className="flex-1 p-4 lg:p-8">
          <Outlet />
        </main>
        <footer className="border-t border-gray-200 bg-white py-3 px-4 lg:px-8 text-center text-xs text-gray-500">
          Developed by{' '}
          <a
            href="https://inmassat.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#0B5D1E] hover:text-[#062E10] hover:underline font-medium"
          >
            Inmassat Global Network Company
          </a>
        </footer>
      </div>
    </div>
    </>
  );
}
